export default "__VITE_ASSET__bKSNsZsX__"